import { render, staticRenderFns } from "./settings-nonmember.vue?vue&type=template&id=3ca41574&"
import script from "./settings-nonmember.vue?vue&type=script&lang=js&"
export * from "./settings-nonmember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports